import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './search-panel-result.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class SearchPanelResult extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      /**
       * Main content area title
       */
      title: { type: String },
      styleclass: { type: String },
      url: { type: String },
      suggestedOnly: { type: Boolean },
      mainMenuSearch: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.styleclass = 'default';
    this.url = '/search?search=';
    this.suggestedOnly = false;
    this.mainMenuSearch = false;
  }

  renderShowAll() {
    return html`${this.styleclass === 'default'
      ? html`<a class="search-panel-result__see-all" href="${this.url}">
          See all
          <hf-icon
            name="arrow-right"
            class="search__panel__item-icon"
            color="purple"
          ></hf-icon>
        </a>`
      : html`<hf-button
          type="search-all"
          class="search-panel-result__see-all"
          icon="arrow-right"
          href="${this.url}"
        >
          See all results
        </hf-button>`}`;
  }

  render() {
    return html`
      <div 
        class="${classMap({
          'search-panel-result': true,
          [`search-panel-result--${this.styleclass}`]: true,
          'search-panel-result--main-menu-search': this.mainMenuSearch,
        })}"
      >
        <hf-heading
          class="search-panel-result__heading"
          level="5"
          levelStyle="heading5"
        >
          ${this.title}
        </hf-heading>
        <div class="search-panel-result__results">
          <slot></slot>
        </div>
        ${this.suggestedOnly ? nothing : this.renderShowAll()}
      </div>
    `;
  }
}
customElements.define('hf-search-panel-result', SearchPanelResult);
